// Recovered from 6499828760bc77eb524624aac3a1d6ae80401e8d:traverseclean/src/pages/WorkerApp.js
// Extracted CHECKLISTS, SE_CHECKLIST, getFilteredTasks, getChecklist

export const SE_CHECKLIST = { zones: [
  { name: 'During the Event', note: 'Keep on top of these throughout. Min. 2 staff required.', tasks: [
    { id: 'SE-D1', label: 'Change garbage bins as they fill — dispose in outside dumpsters', freq: 'daily' },
    { id: 'SE-D2', label: 'Change recycling bins — clear blue bags, separate from garbage', freq: 'daily' },
    { id: 'SE-D3', label: 'Check & clean washrooms — toilets, sinks, floors', freq: 'daily' },
    { id: 'SE-D4', label: 'Refill soap, paper towels and toilet paper dispensers', freq: 'daily' },
    { id: 'SE-D5', label: 'Clean up wet floors or spills immediately', freq: 'daily' },
    { id: 'SE-D6', label: 'Other incidentals as required during the event', freq: 'daily' },
  ]},
  { name: 'After the Event', note: 'Min. 2 staff for table & chair breakdown. Do not leave until all tasks complete.', tasks: [
    { id: 'SE-A1', label: 'Remove all garbage & recycling left on tables', freq: 'daily' },
    { id: 'SE-A2', label: 'Clean & sanitize all tables used at the event', freq: 'daily' },
    { id: 'SE-A3', label: 'Clean & sanitize all chairs used at the event', freq: 'daily' },
    { id: 'SE-A4', label: 'Remove tables and store in designated storage area', freq: 'daily' },
    { id: 'SE-A5', label: 'Remove chairs and store in designated storage area', freq: 'daily' },
    { id: 'SE-A6', label: 'Sweep & wash floors in all event room(s)', freq: 'daily' },
    { id: 'SE-A7', label: 'Final washroom check — clean & restock all dispensers', freq: 'daily' },
    { id: 'SE-A8', label: 'Empty all remaining garbage & recycling bins', freq: 'daily' },
    { id: 'SE-A9', label: 'Final walk-through of all event areas', freq: 'daily' },
  ]},
]};

export const CHECKLISTS = {
  B: { zones: [
    { name: 'General Areas', note: 'Excluded: Garage. Clean eating/food prep, washrooms, locker room, hallways, office only.', tasks: [
      { id: 'B-G1', label: 'Empty all garbage receptacles & wipe down lids', freq: 'daily' },
      { id: 'B-G2', label: 'Dispose of trash in outside bins', freq: 'daily' },
      { id: 'B-G3', label: 'Dust and spot clean all furniture', freq: 'daily' },
      { id: 'B-G4', label: 'Sanitize all door handles', freq: 'daily' },
      { id: 'B-G5', label: 'Remove fingerprints & smudges from all surfaces', freq: 'daily' },
      { id: 'B-G6', label: 'Clean counter tops & metal surfaces', freq: 'daily' },
      { id: 'B-G7', label: 'Spot clean walls', freq: 'daily' },
      { id: 'B-G8', label: 'Low dust horizontal surfaces to hand height', freq: 'daily' },
      { id: 'B-G9', label: 'Clean high touch surfaces', freq: 'daily' },
      { id: 'B-G10', label: 'Clean baseboard heaters', freq: 'monthly' },
      { id: 'B-G11', label: 'Clean wall surfaces', freq: 'semi-annual' },
      { id: 'B-G12', label: 'High dust horizontal surfaces above hand height', freq: 'semi-annual' },
    ]},
    { name: 'Kitchen / Eating Area', tasks: [
      { id: 'B-K1', label: 'Wash & sanitize counter surfaces, sink and table(s)', freq: 'daily' },
      { id: 'B-K2', label: 'Wash stove top', freq: 'daily' },
      { id: 'B-K3', label: 'Wash & sanitize floors', freq: 'daily' },
      { id: 'B-K4', label: 'Refill all dispensers / toiletries', freq: 'daily' },
      { id: 'B-K5', label: 'Empty recycling receptacles', freq: 'daily' },
      { id: 'B-K6', label: 'Clean microwave inside, outside & underneath', freq: 'weekly' },
      { id: 'B-K7', label: 'Clean chairs', freq: 'weekly' },
      { id: 'B-K8', label: 'Wipe down cupboard doors (inside & out)', freq: 'monthly' },
      { id: 'B-K9', label: 'Clean & sanitize refrigerators', freq: 'monthly' },
      { id: 'B-K10', label: 'Clean underneath all kitchen equipment', freq: 'semi-annual' },
    ]},
    { name: 'Washrooms', tasks: [
      { id: 'B-W1', label: 'Clean & sanitize toilets and urinals', freq: 'daily' },
      { id: 'B-W2', label: 'Clean & sanitize sink and counters', freq: 'daily' },
      { id: 'B-W3', label: 'Clean mirrors', freq: 'daily' },
      { id: 'B-W4', label: 'Spot clean walls & metal partitions', freq: 'daily' },
      { id: 'B-W5', label: 'Wash & sanitize floors', freq: 'daily' },
      { id: 'B-W6', label: 'Empty napkin disposals & insert liners', freq: 'daily' },
      { id: 'B-W7', label: 'Refill all dispensers / toiletries', freq: 'daily' },
      { id: 'B-W8', label: 'Clean all washroom wall surfaces', freq: 'semi-annual' },
    ]},
    { name: 'Floors', tasks: [
      { id: 'B-F1', label: 'Sweep & wash resilient and hard floors', freq: 'daily' },
      { id: 'B-F2', label: 'Clean baseboards', freq: 'monthly' },
      { id: 'B-F3', label: 'Strip, neutralize, apply sealer + 3 coats wax & buff', freq: 'annual' },
    ]},
  ]},
  C: { zones: [
    { name: 'General Areas', note: 'Trailer only — bring all supplies. No on-site storage.', tasks: [
      { id: 'C-G1', label: 'Empty all garbage receptacles & wipe down lids', freq: 'daily' },
      { id: 'C-G2', label: 'Dispose of trash — transport to nearest dumpster site', freq: 'daily' },
      { id: 'C-G3', label: 'Dust and spot clean all surfaces and furniture', freq: 'daily' },
      { id: 'C-G4', label: 'Sanitize all door handles and high touch surfaces', freq: 'daily' },
      { id: 'C-G5', label: 'Spot clean walls', freq: 'daily' },
      { id: 'C-G6', label: 'Sweep & wash floors', freq: 'daily' },
      { id: 'C-G7', label: 'Clean wall surfaces', freq: 'semi-annual' },
    ]},
    { name: 'Washroom', tasks: [
      { id: 'C-W1', label: 'Clean & sanitize toilet', freq: 'daily' },
      { id: 'C-W2', label: 'Clean & sanitize sink and counter', freq: 'daily' },
      { id: 'C-W3', label: 'Clean mirror', freq: 'daily' },
      { id: 'C-W4', label: 'Wash & sanitize floor', freq: 'daily' },
      { id: 'C-W5', label: 'Refill all dispensers / toiletries', freq: 'daily' },
    ]},
  ]},
  D: { zones: [
    { name: 'Office & Washroom ONLY', note: '⚠️ RESTRICTED — Do not enter any plant areas.', tasks: [
      { id: 'D-G1', label: 'Empty all garbage receptacles', freq: 'weekly' },
      { id: 'D-G2', label: 'Dust and spot clean office furniture and surfaces', freq: 'weekly' },
      { id: 'D-G3', label: 'Sanitize door handles and high touch surfaces', freq: 'weekly' },
      { id: 'D-G4', label: 'Sweep & wash office floor', freq: 'weekly' },
      { id: 'D-W1', label: 'Clean & sanitize toilet', freq: 'weekly' },
      { id: 'D-W2', label: 'Clean & sanitize sink and counter', freq: 'weekly' },
      { id: 'D-W3', label: 'Clean mirror', freq: 'weekly' },
      { id: 'D-W4', label: 'Wash & sanitize floor', freq: 'weekly' },
      { id: 'D-W5', label: 'Refill all dispensers / toiletries', freq: 'weekly' },
      { id: 'D-W6', label: 'Empty napkin disposals & insert liners', freq: 'weekly' },
    ]},
  ]},
  E: { zones: [
    { name: 'General Areas', note: '🌿 LEED — approved products only. Min. 2 staff at all times.', tasks: [
      { id: 'E-G1', label: 'Empty all garbage receptacles & wipe down lids', freq: 'twice-daily' },
      { id: 'E-G2', label: 'Dispose of trash in outside dumpsters', freq: 'twice-daily' },
      { id: 'E-G3', label: 'Empty recycling receptacles (not paper in offices)', freq: 'twice-daily' },
      { id: 'E-G4', label: 'Clean counter tops', freq: 'twice-daily' },
      { id: 'E-G5', label: 'Dust and spot clean all furniture', freq: 'twice-daily' },
      { id: 'E-G6', label: 'Wipe desktops including boardroom table(s)', freq: 'twice-daily' },
      { id: 'E-G7', label: 'Sanitize all door handles', freq: 'twice-daily' },
      { id: 'E-G8', label: 'Spot clean walls', freq: 'twice-daily' },
      { id: 'E-G9', label: 'Clean high touch surfaces', freq: 'twice-daily' },
      { id: 'E-G10', label: 'Remove fingerprints & smudges from all surfaces', freq: 'twice-daily' },
      { id: 'E-G11', label: 'Damp wipe furniture', freq: 'weekly' },
      { id: 'E-G12', label: 'Clean all interior glass', freq: 'weekly' },
      { id: 'E-G13', label: 'Low dust horizontal surfaces to hand height', freq: 'weekly' },
      { id: 'E-G14', label: 'Clean & polish metal surfaces', freq: 'monthly' },
      { id: 'E-G15', label: 'Clean baseboard heaters', freq: 'monthly' },
      { id: 'E-G16', label: 'Clean all wall surfaces', freq: 'semi-annual' },
      { id: 'E-G17', label: 'High dust horizontal surfaces above hand height', freq: 'semi-annual' },
    ]},
    { name: 'Floors — Resilient & Hard', tasks: [
      { id: 'E-F1', label: 'Sweep resilient and hard floors in whole facility', freq: 'twice-daily' },
      { id: 'E-F2', label: 'Wash/disinfect resilient and hard floors in whole facility', freq: 'nightly' },
      { id: 'E-F3', label: 'Spray buff to a high gloss (every Friday)', freq: 'weekly' },
      { id: 'E-F4', label: 'Clean baseboards', freq: 'monthly' },
      { id: 'E-F5', label: 'Strip, neutralize, apply sealer + 2–3 coats finish & buff', freq: 'annual' },
    ]},
    { name: 'Kitchens, Lunchrooms & Eating Areas', note: 'Including tables & chairs in foyer', tasks: [
      { id: 'E-K1', label: 'Wash & sanitize counter surfaces, sinks and tables', freq: 'nightly' },
      { id: 'E-K2', label: 'Run dishwasher (dirty dishes in, clean dishes to cupboards)', freq: 'nightly' },
      { id: 'E-K3', label: 'Refill all dispensers/toiletries', freq: 'nightly' },
      { id: 'E-K4', label: 'Change recycling bins', freq: 'nightly' },
      { id: 'E-K5', label: 'Clean microwave(s) inside, outside & underneath', freq: 'weekly' },
      { id: 'E-K6', label: 'Wipe chairs', freq: 'weekly' },
      { id: 'E-K7', label: 'Wipe down cupboard doors (inside & out)', freq: 'monthly' },
      { id: 'E-K8', label: 'Clean & sanitize refrigerators', freq: 'monthly' },
      { id: 'E-K9', label: 'Clean stove(s)', freq: 'monthly' },
      { id: 'E-K10', label: 'Clean underneath all kitchen equipment', freq: 'monthly' },
    ]},
    { name: 'Washrooms, Change Rooms & Dressing Rooms', note: 'Including Arena, Fitness Centre — separate areas', tasks: [
      { id: 'E-W1', label: 'Clean & sanitize all toilets and urinals', freq: 'twice-daily' },
      { id: 'E-W2', label: 'Clean & sanitize sinks and counters', freq: 'twice-daily' },
      { id: 'E-W3', label: 'Clean & polish chrome fittings', freq: 'twice-daily' },
      { id: 'E-W4', label: 'Clean mirrors', freq: 'twice-daily' },
      { id: 'E-W5', label: 'Wash & disinfect floors', freq: 'nightly' },
      { id: 'E-W6', label: 'Spot clean walls', freq: 'nightly' },
      { id: 'E-W7', label: 'Empty napkin disposals & insert liners', freq: 'nightly' },
      { id: 'E-W8', label: 'Refill all dispensers/toiletries', freq: 'nightly' },
      { id: 'E-W9', label: 'Scrub & disinfect shower floors and walls', freq: 'nightly' },
      { id: 'E-W10', label: 'Clean shower drains', freq: 'nightly' },
      { id: 'E-W11', label: 'Wash & disinfect change room benches', freq: 'twice-daily' },
      { id: 'E-W12', label: 'Clean & sanitize baby change table(s)', freq: 'nightly' },
      { id: 'E-W13', label: 'Wash & sanitize metal partitions', freq: 'weekly' },
      { id: 'E-W14', label: 'Clean all washroom wall surfaces (excl. metal partitions)', freq: 'semi-annual' },
    ]},
    { name: 'Fitness Centre & Change Rooms', tasks: [
      { id: 'E-FC1', label: 'Empty all garbage receptacles & wipe lids', freq: 'twice-daily' },
      { id: 'E-FC2', label: 'Dispose of trash', freq: 'twice-daily' },
      { id: 'E-FC3', label: 'Empty recycling receptacles', freq: 'twice-daily' },
      { id: 'E-FC4', label: 'Remove fingerprints from surfaces (mirrors)', freq: 'twice-daily' },
      { id: 'E-FC5', label: 'Change room — general tidiness', freq: 'twice-daily' },
      { id: 'E-FC6', label: 'Wipe plumbing fixtures', freq: 'twice-daily' },
      { id: 'E-FC7', label: 'Refill all dispensers as required', freq: 'twice-daily' },
      { id: 'E-FC8', label: 'Clean water dispensers', freq: 'twice-daily' },
      { id: 'E-FC9', label: 'Clean shoe shelves', freq: 'nightly' },
      { id: 'E-FC10', label: 'Clean all interior glass', freq: 'nightly' },
      { id: 'E-FC11', label: 'Vacuum floor', freq: 'nightly' },
      { id: 'E-FC12', label: 'Wash gym floor', freq: 'nightly' },
      { id: 'E-FC13', label: 'Wipe down inside of lockers', freq: 'weekly' },
      { id: 'E-FC14', label: 'Spot clean walls', freq: 'weekly' },
      { id: 'E-FC15', label: 'Thorough wipe down/disinfect all walls in fitness centre & change rooms', freq: 'semi-annual' },
    ]},
    { name: 'Arena — Ice Areas', note: 'Public areas only — do not enter ice surface.', tasks: [
      { id: 'E-I1', label: 'Seating area (bleachers) — wipe & sanitize or fog/disinfect', freq: 'after-rental' },
      { id: 'E-I2', label: 'Sweep/wash concourse Rink A', freq: 'nightly' },
      { id: 'E-I3', label: 'Sweep/wash concourse Rink B', freq: 'nightly' },
      { id: 'E-I4', label: 'Sweep stairwells in Rink B', freq: 'nightly' },
    ]},
    { name: 'Miscellaneous', tasks: [
      { id: 'E-M1', label: 'Clean inside of windows', freq: 'semi-annual' },
      { id: 'E-M2', label: 'Clean vertical blinds', freq: 'semi-annual' },
      { id: 'E-M3', label: 'Vacuum/clean air grilles and diffusers', freq: 'semi-annual' },
    ]},
  ]},
  F: { sharedWith: 'E', zones: [
    { name: 'General Areas', note: '🌿 LEED — approved products only.', tasks: [
      { id: 'F-G1', label: 'Empty all garbage receptacles & wipe lids', freq: 'twice-daily' },
      { id: 'F-G2', label: 'Dispose of trash in outside dumpsters', freq: 'twice-daily' },
      { id: 'F-G3', label: 'Empty recycling receptacles', freq: 'twice-daily' },
      { id: 'F-G4', label: 'Clean counter tops', freq: 'twice-daily' },
      { id: 'F-G5', label: 'Dust and spot clean all furniture', freq: 'twice-daily' },
      { id: 'F-G6', label: 'Wipe desktops including boardroom table(s)', freq: 'twice-daily' },
      { id: 'F-G7', label: 'Sanitize all door handles', freq: 'twice-daily' },
      { id: 'F-G8', label: 'Spot clean walls', freq: 'twice-daily' },
      { id: 'F-G9', label: 'Clean high touch surfaces', freq: 'twice-daily' },
      { id: 'F-G10', label: 'Remove fingerprints & smudges from all surfaces', freq: 'twice-daily' },
      { id: 'F-G11', label: 'Damp wipe furniture', freq: 'weekly' },
      { id: 'F-G12', label: 'Clean all interior glass', freq: 'weekly' },
      { id: 'F-G13', label: 'Low dust horizontal surfaces to hand height', freq: 'weekly' },
      { id: 'F-G14', label: 'Clean & polish metal surfaces', freq: 'monthly' },
      { id: 'F-G15', label: 'Clean all wall surfaces', freq: 'semi-annual' },
      { id: 'F-G16', label: 'High dust horizontal surfaces above hand height', freq: 'semi-annual' },
    ]},
    { name: 'Washrooms', tasks: [
      { id: 'F-W1', label: 'Clean & sanitize all toilets and urinals', freq: 'twice-daily' },
      { id: 'F-W2', label: 'Clean & sanitize sinks and counters', freq: 'twice-daily' },
      { id: 'F-W3', label: 'Clean & polish chrome fittings', freq: 'twice-daily' },
      { id: 'F-W4', label: 'Clean mirrors', freq: 'twice-daily' },
      { id: 'F-W5', label: 'Wash & disinfect floors', freq: 'nightly' },
      { id: 'F-W6', label: 'Spot clean walls', freq: 'nightly' },
      { id: 'F-W7', label: 'Empty napkin disposals & insert liners', freq: 'nightly' },
      { id: 'F-W8', label: 'Refill all dispensers/toiletries', freq: 'nightly' },
      { id: 'F-W9', label: 'Wash & sanitize metal partitions', freq: 'weekly' },
      { id: 'F-W10', label: 'Clean all washroom wall surfaces (excl. metal partitions)', freq: 'semi-annual' },
    ]},
    { name: 'Gym, Youth Room & Multipurpose Rooms', tasks: [
      { id: 'F-GY1', label: 'Sweep and wash gym floor', freq: 'nightly' },
      { id: 'F-GY2', label: 'Empty garbage & recycling', freq: 'twice-daily' },
      { id: 'F-GY3', label: 'Clean all surfaces and equipment', freq: 'nightly' },
      { id: 'F-GY4', label: 'Spot clean walls', freq: 'nightly' },
    ]},
    { name: 'Kitchen/Eating Areas', tasks: [
      { id: 'F-K1', label: 'Wash & sanitize counter surfaces, sinks and tables', freq: 'nightly' },
      { id: 'F-K2', label: 'Refill all dispensers/toiletries', freq: 'nightly' },
      { id: 'F-K3', label: 'Change recycling bins', freq: 'nightly' },
      { id: 'F-K4', label: 'Clean microwave(s) inside, outside & underneath', freq: 'weekly' },
      { id: 'F-K5', label: 'Wipe chairs', freq: 'weekly' },
      { id: 'F-K6', label: 'Wipe down cupboard doors (inside & out)', freq: 'monthly' },
      { id: 'F-K7', label: 'Clean & sanitize refrigerators', freq: 'monthly' },
    ]},
    { name: 'Floors', tasks: [
      { id: 'F-F1', label: 'Sweep resilient and hard floors', freq: 'twice-daily' },
      { id: 'F-F2', label: 'Wash/disinfect resilient and hard floors', freq: 'nightly' },
      { id: 'F-F3', label: 'Spray buff to a high gloss (Fridays)', freq: 'weekly' },
      { id: 'F-F4', label: 'Clean baseboards', freq: 'monthly' },
    ]},
    { name: 'Skate Park', tasks: [
      { id: 'F-SP1', label: 'Sweep and wash floors', freq: 'nightly' },
      { id: 'F-SP2', label: 'Empty garbage', freq: 'twice-daily' },
      { id: 'F-SP3', label: 'Clean surfaces', freq: 'nightly' },
    ]},
  ]},
  G: { zones: [
    { name: 'Concession & Common Areas', note: 'Canteen/food prep cleaned by tenant. Change rooms seasonal (Jun 18 – Sep 23).', tasks: [
      { id: 'G-G1', label: 'Empty all garbage receptacles', freq: 'after-rental' },
      { id: 'G-G2', label: 'Dispose of trash in outside dumpsters (arena)', freq: 'after-rental' },
      { id: 'G-G3', label: 'Damp wipe table and chairs', freq: 'after-rental' },
      { id: 'G-G4', label: 'Sanitize all door handles', freq: 'after-rental' },
      { id: 'G-G5', label: 'Remove fingerprints & smudges from all surfaces', freq: 'after-rental' },
      { id: 'G-G6', label: 'Spot clean walls', freq: 'after-rental' },
      { id: 'G-G7', label: 'Clean high touch surfaces', freq: 'after-rental' },
      { id: 'G-G8', label: 'Change recycling bins', freq: 'after-rental' },
      { id: 'G-G9', label: 'Clean all interior glass (excl. windows)', freq: 'weekly' },
      { id: 'G-G10', label: 'Clean & polish any metal surfaces', freq: 'weekly' },
      { id: 'G-G11', label: 'Low dust horizontal surfaces to hand height', freq: 'monthly' },
      { id: 'G-G12', label: 'Clean baseboards and baseboard heaters', freq: 'monthly' },
      { id: 'G-G13', label: 'High dust horizontal surfaces above hand height', freq: 'semi-annual' },
      { id: 'G-G14', label: 'Clean wall surfaces', freq: 'semi-annual' },
    ]},
    { name: 'Outside Washrooms', note: '⚠️ Year-round, 7 days/week after 9pm. SET ALARM when leaving.', tasks: [
      { id: 'G-OW1', label: 'Clean & sanitize toilets and urinals', freq: 'daily' },
      { id: 'G-OW2', label: 'Clean & sanitize sink and counters', freq: 'daily' },
      { id: 'G-OW3', label: 'Clean & polish chrome fittings', freq: 'daily' },
      { id: 'G-OW4', label: 'Clean mirrors', freq: 'daily' },
      { id: 'G-OW5', label: 'Wash & sanitize floors', freq: 'daily' },
      { id: 'G-OW6', label: 'Spot clean walls', freq: 'daily' },
      { id: 'G-OW7', label: 'Empty napkin disposals & insert liners', freq: 'daily' },
      { id: 'G-OW8', label: 'Refill all dispensers/toiletries', freq: 'daily' },
      { id: 'G-OW9', label: 'Wash & sanitize metal partitions', freq: 'weekly' },
      { id: 'G-OW10', label: 'Clean all washroom wall surfaces (excl. partitions)', freq: 'semi-annual' },
    ]},
    { name: 'Indoor Washrooms & Change Rooms', note: 'Including staff washroom. Seasonal: Jun 18 – Sep 23.', tasks: [
      { id: 'G-W1', label: 'Clean & sanitize toilets and urinals', freq: 'after-rental' },
      { id: 'G-W2', label: 'Clean & sanitize sinks and counters', freq: 'after-rental' },
      { id: 'G-W3', label: 'Clean & polish chrome fittings', freq: 'after-rental' },
      { id: 'G-W4', label: 'Clean mirrors', freq: 'after-rental' },
      { id: 'G-W5', label: 'Wash & disinfect all floors', freq: 'after-rental' },
      { id: 'G-W6', label: 'Spot clean walls', freq: 'after-rental' },
      { id: 'G-W7', label: 'Empty napkin disposals & insert liners', freq: 'after-rental' },
      { id: 'G-W8', label: 'Wash & disinfect change room benches', freq: 'after-rental' },
      { id: 'G-W9', label: 'Scrub & disinfect shower floors and walls', freq: 'after-rental' },
      { id: 'G-W10', label: 'Clean shower drains', freq: 'after-rental' },
      { id: 'G-W11', label: 'Refill all dispensers/toiletries', freq: 'after-rental' },
    ]},
    { name: 'Floors', tasks: [
      { id: 'G-F1', label: 'Sweep & wash resilient and hard floors', freq: 'after-rental' },
    ]},
  ]},
  H: { zones: [
    { name: 'General Areas', note: 'No on-site storage — bring all supplies. Rental-based cleaning per Town schedule.', tasks: [
      { id: 'H-G1', label: 'Empty all garbage receptacles', freq: 'after-rental' },
      { id: 'H-G2', label: 'Transport trash to nearest dumpster site', freq: 'after-rental' },
      { id: 'H-G3', label: 'Spot clean surfaces and high touch areas', freq: 'after-rental' },
      { id: 'H-G4', label: 'Sweep & wash hard floors', freq: 'after-rental' },
      { id: 'H-G5', label: 'Wipe down tables and chairs', freq: 'after-rental' },
    ]},
    { name: 'Washrooms', tasks: [
      { id: 'H-W1', label: 'Clean & sanitize toilets and urinals', freq: 'after-rental' },
      { id: 'H-W2', label: 'Clean & sanitize sinks and counters', freq: 'after-rental' },
      { id: 'H-W3', label: 'Clean mirrors', freq: 'after-rental' },
      { id: 'H-W4', label: 'Wash & sanitize floors', freq: 'after-rental' },
      { id: 'H-W5', label: 'Refill all dispensers / toiletries', freq: 'after-rental' },
      { id: 'H-W6', label: 'Empty napkin disposals & insert liners', freq: 'after-rental' },
    ]},
  ]},
  I: { zones: [
    { name: 'General Areas', note: 'Rental-based cleaning — ~8 cleans/week year-round per Town schedule.', tasks: [
      { id: 'I-G1', label: 'Empty all garbage & recycling receptacles', freq: 'after-rental' },
      { id: 'I-G2', label: 'Dispose of trash in outside dumpsters (St. Thomas Line)', freq: 'after-rental' },
      { id: 'I-G3', label: 'Dust and spot clean all furniture and surfaces', freq: 'after-rental' },
      { id: 'I-G4', label: 'Sanitize all door handles and high touch surfaces', freq: 'after-rental' },
      { id: 'I-G5', label: 'Sweep & wash hard floors', freq: 'after-rental' },
      { id: 'I-G6', label: 'Spot clean walls', freq: 'after-rental' },
      { id: 'I-G7', label: 'Wipe tables and chairs after rental', freq: 'after-rental' },
    ]},
    { name: 'Washrooms', tasks: [
      { id: 'I-W1', label: 'Clean & sanitize toilets and urinals', freq: 'after-rental' },
      { id: 'I-W2', label: 'Clean & sanitize sinks and counters', freq: 'after-rental' },
      { id: 'I-W3', label: 'Clean mirrors', freq: 'after-rental' },
      { id: 'I-W4', label: 'Wash & sanitize floors', freq: 'after-rental' },
      { id: 'I-W5', label: 'Refill all dispensers / toiletries', freq: 'after-rental' },
      { id: 'I-W6', label: 'Empty napkin disposals & insert liners', freq: 'after-rental' },
    ]},
    { name: 'Kitchen', tasks: [
      { id: 'I-K1', label: 'Wash & sanitize counter surfaces and sink', freq: 'after-rental' },
      { id: 'I-K2', label: 'Wash & sanitize floor', freq: 'after-rental' },
      { id: 'I-K3', label: 'Refill dispensers', freq: 'after-rental' },
      { id: 'I-K4', label: 'Empty recycling', freq: 'after-rental' },
    ]},
  ]},
  J: { zones: [
    { name: 'General Areas', note: 'Min. 2 hrs × 2 staff per clean. Per Town rental schedule.', tasks: [
      { id: 'J-G1', label: 'Empty all garbage & recycling receptacles', freq: 'after-rental' },
      { id: 'J-G2', label: 'Transport trash to nearest dumpster site', freq: 'after-rental' },
      { id: 'J-G3', label: 'Dust and spot clean all surfaces and furniture', freq: 'after-rental' },
      { id: 'J-G4', label: 'Sanitize door handles and high touch surfaces', freq: 'after-rental' },
      { id: 'J-G5', label: 'Sweep & wash hard floors', freq: 'after-rental' },
      { id: 'J-G6', label: 'Spot clean walls', freq: 'after-rental' },
      { id: 'J-G7', label: 'Wipe tables and chairs', freq: 'after-rental' },
    ]},
    { name: 'Washrooms', tasks: [
      { id: 'J-W1', label: 'Clean & sanitize toilets and urinals', freq: 'after-rental' },
      { id: 'J-W2', label: 'Clean & sanitize sinks and counters', freq: 'after-rental' },
      { id: 'J-W3', label: 'Clean mirrors', freq: 'after-rental' },
      { id: 'J-W4', label: 'Wash & sanitize floors', freq: 'after-rental' },
      { id: 'J-W5', label: 'Refill all dispensers / toiletries', freq: 'after-rental' },
      { id: 'J-W6', label: 'Empty napkin disposals & insert liners', freq: 'after-rental' },
    ]},
    { name: 'Kitchen / Bar Area', tasks: [
      { id: 'J-K1', label: 'Wash & sanitize counter surfaces and sink', freq: 'after-rental' },
      { id: 'J-K2', label: 'Wash & sanitize floor', freq: 'after-rental' },
      { id: 'J-K3', label: 'Refill dispensers', freq: 'after-rental' },
      { id: 'J-K4', label: 'Empty recycling', freq: 'after-rental' },
    ]},
  ]},
  K: { zones: [
    { name: 'Outside Washrooms', note: '⚠️ CRITICAL: Outside washrooms TWICE DAILY every day year-round including holidays. Evening clean at 9:30pm.', tasks: [
      { id: 'K-OW1', label: 'Clean & sanitize all toilets', freq: 'twice-daily' },
      { id: 'K-OW2', label: 'Clean & sanitize sinks and counters', freq: 'twice-daily' },
      { id: 'K-OW3', label: 'Clean mirrors', freq: 'twice-daily' },
      { id: 'K-OW4', label: 'Wash & sanitize floors', freq: 'twice-daily' },
      { id: 'K-OW5', label: 'Refill all dispensers / toiletries', freq: 'twice-daily' },
      { id: 'K-OW6', label: 'Empty garbage receptacles', freq: 'twice-daily' },
      { id: 'K-OW7', label: 'Dispose of trash in outside dumpsters (Peter Barry Duff)', freq: 'twice-daily' },
    ]},
    { name: 'Building Interior', note: 'Interior cleaned after rentals per Town schedule.', tasks: [
      { id: 'K-G1', label: 'Sweep & wash interior floors', freq: 'after-rental' },
      { id: 'K-G2', label: 'Spot clean surfaces and high touch areas', freq: 'after-rental' },
      { id: 'K-G3', label: 'Empty interior garbage receptacles', freq: 'after-rental' },
      { id: 'K-G4', label: 'Wipe tables and chairs', freq: 'after-rental' },
    ]},
  ]},
  L: { sharedWith: 'D', zones: [
    { name: 'Office & Washroom ONLY', note: '⚠️ RESTRICTED — Office and washroom only. Same Monday morning run as Building D.', tasks: [
      { id: 'L-G1', label: 'Empty all garbage receptacles', freq: 'weekly' },
      { id: 'L-G2', label: 'Dust and spot clean office furniture and surfaces', freq: 'weekly' },
      { id: 'L-G3', label: 'Sanitize door handles and high touch surfaces', freq: 'weekly' },
      { id: 'L-G4', label: 'Sweep & wash office floor', freq: 'weekly' },
      { id: 'L-W1', label: 'Clean & sanitize toilet', freq: 'weekly' },
      { id: 'L-W2', label: 'Clean & sanitize sink and counter', freq: 'weekly' },
      { id: 'L-W3', label: 'Clean mirror', freq: 'weekly' },
      { id: 'L-W4', label: 'Wash & sanitize floor', freq: 'weekly' },
      { id: 'L-W5', label: 'Refill all dispensers / toiletries', freq: 'weekly' },
    ]},
  ]},
  N: { sharedWith: 'A', zones: [
    { name: 'General Areas', note: 'Rented Town Hall Space. Twice daily cleaning.', tasks: [
      { id: 'N-G1', label: 'Empty all garbage receptacles & wipe down lids', freq: 'daily' },
      { id: 'N-G2', label: 'Dispose of trash', freq: 'daily' },
      { id: 'N-G3', label: 'Dust and spot clean all furniture', freq: 'daily' },
      { id: 'N-G4', label: 'Wipe desktops including boardroom table & council desks', freq: 'daily' },
      { id: 'N-G5', label: 'Sanitize all door handles', freq: 'daily' },
      { id: 'N-G6', label: 'Remove fingerprints & smudges from all surfaces', freq: 'daily' },
      { id: 'N-G7', label: 'Clean counter tops — lobby area', freq: 'daily' },
      { id: 'N-G8', label: 'Spot clean walls', freq: 'daily' },
      { id: 'N-G9', label: 'Clean high touch surfaces', freq: 'daily' },
      { id: 'N-G10', label: 'Damp wipe furniture', freq: 'weekly' },
      { id: 'N-G11', label: 'Clean all interior glass (excl. external windows)', freq: 'weekly' },
      { id: 'N-G12', label: 'Clean & polish any metal surfaces', freq: 'weekly' },
      { id: 'N-G13', label: 'Low dust horizontal surfaces to hand height', freq: 'weekly' },
      { id: 'N-G14', label: 'Clean baseboard heaters', freq: 'monthly' },
      { id: 'N-G15', label: 'Clean wall surfaces', freq: 'semi-annual' },
      { id: 'N-G16', label: 'High dust horizontal surfaces above hand height', freq: 'semi-annual' },
    ]},
    { name: 'Kitchen / Eating Area', tasks: [
      { id: 'N-K1', label: 'Wash & sanitize counter surfaces, sink and table(s)', freq: 'daily' },
      { id: 'N-K2', label: 'Wash stove top', freq: 'daily' },
      { id: 'N-K3', label: 'Wash & sanitize floors', freq: 'daily' },
      { id: 'N-K4', label: 'Refill all dispensers/toiletries', freq: 'daily' },
      { id: 'N-K5', label: 'Change recycling bins', freq: 'daily' },
      { id: 'N-K6', label: 'Clean microwave(s) inside, outside & underneath', freq: 'weekly' },
      { id: 'N-K7', label: 'Wipe chairs', freq: 'weekly' },
      { id: 'N-K8', label: 'Wipe down cupboard doors (inside & out)', freq: 'monthly' },
      { id: 'N-K9', label: 'Clean & sanitize refrigerators', freq: 'monthly' },
      { id: 'N-K10', label: 'Clean underneath all kitchen equipment', freq: 'monthly' },
    ]},
    { name: 'Washrooms', tasks: [
      { id: 'N-W1', label: 'Clean & sanitize toilets and urinals', freq: 'daily' },
      { id: 'N-W2', label: 'Clean & sanitize sink and counters', freq: 'daily' },
      { id: 'N-W3', label: 'Clean mirrors', freq: 'daily' },
      { id: 'N-W4', label: 'Spot clean walls & metal partitions', freq: 'daily' },
      { id: 'N-W5', label: 'Wash & sanitize floors', freq: 'daily' },
      { id: 'N-W6', label: 'Empty napkin disposals & insert liners', freq: 'daily' },
      { id: 'N-W7', label: 'Refill all dispensers/toiletries', freq: 'daily' },
      { id: 'N-W8', label: 'Wash & sanitize metal partitions', freq: 'weekly' },
      { id: 'N-W9', label: 'Clean all washroom wall surfaces (excl. partitions)', freq: 'semi-annual' },
    ]},
    { name: 'Floors', tasks: [
      { id: 'N-F1', label: 'Sweep & wash all resilient and hard floors incl. stairwells', freq: 'daily' },
      { id: 'N-F2', label: 'Vacuum carpeted areas & remove spots', freq: 'daily' },
      { id: 'N-F3', label: 'Clean baseboards', freq: 'monthly' },
      { id: 'N-F4', label: 'Spray & buff resilient floors to a high gloss', freq: 'monthly' },
      { id: 'N-F5', label: 'Strip, neutralize, apply sealer + 2-3 coats finish & buff', freq: 'annual' },
      { id: 'N-F6', label: 'Carpet floors — shampoo & steam clean', freq: 'annual' },
    ]},
    { name: 'Miscellaneous', tasks: [
      { id: 'N-M1', label: 'Clean blinds', freq: 'semi-annual' },
      { id: 'N-M2', label: 'Vacuum/clean air grilles and diffusers', freq: 'semi-annual' },
      { id: 'N-M3', label: 'Clean inside of windows', freq: 'annual' },
    ]},
  ]},
};

export function getChecklist(id) {
  if (id === 'SE') return SE_CHECKLIST;
  return CHECKLISTS[id] || null;
}

// Manager-editable checklists live in checklist_zones/checklist_tasks —
// once a building has rows there, this is the source of truth for it.
// Buildings with no rows yet fall back to the static CHECKLISTS object
// above, so this rolls out building by building without breaking the rest.
export async function fetchChecklist(id) {
  if (id === 'SE') return SE_CHECKLIST;
  const { supabase } = await import('./supabase');
  const { data: zones, error } = await supabase
    .from('checklist_zones')
    .select('id, name, note, sort_order, checklist_tasks(id, label, freq, sort_order)')
    .eq('building_id', id)
    .order('sort_order', { ascending: true });
  if (!error && zones && zones.length > 0) {
    return {
      zones: zones.map(z => ({
        name: z.name,
        note: z.note || undefined,
        tasks: [...z.checklist_tasks]
          .sort((a, b) => a.sort_order - b.sort_order)
          .map(t => ({ id: t.id, label: t.label, freq: t.freq })),
      })),
    };
  }
  return CHECKLISTS[id] || null;
}

export function getFilteredTasks(zones, freqs) {
  return zones.map(z => ({ ...z, tasks: z.tasks.filter(t => freqs.includes(t.freq)) })).filter(z => z.tasks.length > 0);
}
